import type { EntityId } from './ids.js';
import type { RecordEnvelope } from './records.js';

export type ReminderState = 'scheduled' | 'fired' | 'snoozed' | 'dismissed' | 'done';

/** Local-first reminder. May stand alone (a labelled nudge) or point at a canonical object. */
export interface Reminder extends RecordEnvelope {
  readonly kind: 'reminder';
  /** Human label shown in lists and (redaction permitting) on delivery channels. */
  readonly label: string;
  /** Optional canonical object this reminder is about. */
  readonly linkedId: EntityId | null;
  /** ISO 8601 local-first fire time. */
  readonly fireAt: string;
  readonly state: ReminderState;
  /** Redaction posture for any future delivery channel. */
  readonly redactByDefault: boolean;
}

export interface ReminderInput {
  readonly label: string;
  readonly fireAt: string;
  readonly linkedId?: EntityId | null;
}

/** A reminder is still pending while scheduled or snoozed. */
export function isReminderPending(state: ReminderState): boolean {
  return state === 'scheduled' || state === 'snoozed';
}
